import React from 'react'
import PropTypes from 'prop-types'
import './RadioButton.scss'

const RadioButton = ({ value, label, name, id, checked }) => {
  return [
    <input
      className="Radiobutton"
      key={id}
      type="radio"
      value={value}
      id={id}
      name={name}
      defaultChecked={checked}
    />,
    <label className="Radiobutton__label" key="label" htmlFor={id}>
      {label}
    </label>,
  ]
}

RadioButton.propTypes = {
  checked: PropTypes.bool,
  value: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.string,
}
export default RadioButton
